export const url = 'https://landscape-proposal-commonwealth-nest.trycloudflare.com/api'
// export const url = 'https://testmyweb.pagekite.me/api'
//export const url = 'http://127.0.0.1:8000/api'
